import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
    Box,
    Button,
    Checkbox,
    Container,
    Divider,
    FormHelperText,
    Link,
    TextField,
    Typography
} from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { apiUrl } from "../../constants";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useSelector } from 'react-redux';
import useCheckToken from '../../hooks/useCheckToken';
import useExchangeToken from "../../hooks/useExchangeToken";

const MySwal = withReactContent(Swal);


const NewMasterPlant = () => {
    const exchangeToken = useExchangeToken();
    const navigate = useNavigate();
    const [isTokenExchanged, setIsTokenExchanged] = useState(false);
    const [error, setError] = useState(null);

    useCheckToken();
    const ac_token = useSelector(state => state.auth.access_token);

    useEffect(() => {
        const fetchMyAPI = async () => {
            try {
                await exchangeToken(); // แลก token ทุกครั้ง
                const id = new URL(window.location.href).searchParams.get("id");
                const url = `${apiUrl.USER}${id}/`;
                const result = await axios.get(url, {
                    headers: { Authorization: `Bearer ${ac_token}` }
                });
                // setValues(result.data); 
            } catch (error) {
                console.error("Error fetching or exchanging token:", error);
                setError("Failed to fetch user data");
            }
        };

        fetchMyAPI();
    }, [ac_token, exchangeToken]);

    // จะทำงานหลังจากUser click submit to post user info to register API
    // const handleRegister = React.useCallback(
    //     async (credentials, setSubmitting, setStatus) => {
    //         // เซตbodyสำหรับpostไปในregister api

    //         var body = {
    //             bu: credentials.bu,
    //             plant_id: credentials.plant.toUpperCase(),
    //             factory: credentials.factory,
    //             line: credentials.line,
    //             module: credentials.module,
    //             status: credentials.status,
    //             check_on: credentials.bu + credentials.plant.toUpperCase() + credentials.factory + credentials.line + credentials.module

    //         }
    //         console.log(body)

    //         const AddUser = async () => {
    //             const result = await axios.post(`${apiUrl.MASTER_PLANT_STD}`, body, {
    //                 headers: {
    //                     Authorization: `Bearer ${ac_token}`,
    //                     // "X-xss-protection": "1; mode=block;",
    //                     // "X-frame-options": "SAMEORIGIN",
    //                     // "X-content-type-options": "nosniff",
    //                     // "Cache-Control": "no-cache, private",
    //                     // "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    //                     // "Content-Security-Policy": "upgrade-insecure-requests; frame-ancestors 'self'"
    //                 }
    //             })
    //             return result.data;
    //         };

    //         // เรียก Adduser เพื่อpost api
    //         const data = await AddUser()

    //         if (data.id) {
    //             MySwal.fire({
    //                 title: 'Good job!',
    //                 text: 'Successfully created new master plant!',
    //                 icon: 'success',
    //                 confirmButtonText: 'Ok,Got it!',
    //                 didOpen: () => {
    //                     const confirmButton = document.querySelector('.swal2-confirm');
    //                     if (confirmButton) {
    //                       confirmButton.style.fontFamily = 'CPF_Imm_Sook';
    //                       confirmButton.style.fontSize = '20px';
    //                     }
    //                   }
    //             }).then(() => {
    //                 // redirect to settings page
    //                 navigate('/list-master-plant', { replace: true });
    //             });
    //         } else {
    //             MySwal.fire({
    //                 title: 'Failed!',
    //                 text: 'Failed to created new master plant!',
    //                 icon: 'error',
    //                 confirmButtonText: 'Ok,Got it!',
    //                 didOpen: () => {
    //                     const confirmButton = document.querySelector('.swal2-confirm');                    
    //                     if (confirmButton) {
    //                       confirmButton.style.fontFamily = 'CPF_Imm_Sook';
    //                       confirmButton.style.fontSize = '20px';
    //                     }
    //                   }
    //             });
    //         }
    //     }
    // );

    const handleRegister = React.useCallback(
        async (credentials, setSubmitting, setStatus) => {
          // เซตbodyสำหรับpostไปในregister api
          const body = {
            bu: credentials.bu,
            plant_id: credentials.plant.toUpperCase(),
            factory: credentials.factory,
            line: credentials.line,
            module: credentials.module,
            status: credentials.status,
            check_on: credentials.bu + credentials.plant.toUpperCase() + credentials.factory + credentials.line + credentials.module
          };
      
          try {
            const AddUser = async () => {
              const result = await axios.post(`${apiUrl.MASTER_PLANT_STD}`, body, {
                headers: {
                  Authorization: `Bearer ${ac_token}`,
                }
              });
              return result.data;
            };
      
            // เรียก AddUser เพื่อ post API
            const data = await AddUser();
      
            if (data.id) {
              MySwal.fire({
                title: 'Good job!',
                text: 'Successfully created new master plant!',
                icon: 'success',
                confirmButtonText: 'Ok,Got it!',
                didOpen: () => {
                  const confirmButton = document.querySelector('.swal2-confirm');
                  if (confirmButton) {
                    confirmButton.style.fontFamily = 'CPF_Imm_Sook';
                    confirmButton.style.fontSize = '20px';
                  }
                }
              }).then(() => {
                // redirect to settings page
                navigate('/setting/list-master-plant', { replace: true });
              });
            }
          } catch (error) {
            // ถ้า API ตอบกลับด้วย status 500
            if (error.response && error.response.status === 500) {
              MySwal.fire({
                title: 'Duplicate Entry!',
                text: 'ข้อมูลนี้มีอยู่ในระบบแล้ว กรุณาตรวจสอบอีกครั้ง',
                icon: 'warning',
                confirmButtonText: 'Ok,Got it!',
                didOpen: () => {
                  const confirmButton = document.querySelector('.swal2-confirm');
                  if (confirmButton) {
                    confirmButton.style.fontFamily = 'CPF_Imm_Sook';
                    confirmButton.style.fontSize = '20px';
                  }
                }
              });
            } else {
              // หากเกิดข้อผิดพลาดอื่น ๆ
              MySwal.fire({
                title: 'Failed!',
                text: 'Failed to create new master plant!',
                icon: 'error',
                confirmButtonText: 'Ok,Got it!',
                didOpen: () => {
                  const confirmButton = document.querySelector('.swal2-confirm');
                  if (confirmButton) {
                    confirmButton.style.fontFamily = 'CPF_Imm_Sook';
                    confirmButton.style.fontSize = '20px';
                  }
                }
              });
            }
          }
        },
        []
      );
      
    return (
        <>
            <Helmet>
                <title>New Master Plant | MES </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: '#f5f5f5',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                }}
            >
                <Container maxWidth="md">
                    <Formik
                        initialValues={{
                            bu: '',
                            plant_id: '',
                            factory: '',
                            line: '',
                            module: '',
                            status: ''
                        }}
                        validationSchema={Yup.object().shape({
                            bu: Yup.string()
                                .max(255)
                                .required('Bu is required'),
                            plant: Yup.string().max(255).required('Plant is required'),
                            factory: Yup.string().max(255).required('Factory is required'),
                            line: Yup.string().max(255).required('Line is required'),
                            module: Yup.string().max(255).required('Module is required'),
                            status: Yup.string().max(255).required('Status is required'),
                        })}
                        onSubmit={async (values, { setSubmitting, setStatus }) => {
                            setSubmitting(true);
                            handleRegister(values, setSubmitting, setStatus);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            status
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box sx={{ mb: 3, mt: 1 }}>
                                    <Typography color="textPrimary" style={{ fontSize: 68 }}>
                                        New Master Plant
                                    </Typography>
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        style={{ fontSize: 20 }}
                                    >

                                    </Typography>
                                </Box>
                                {status}
                                <TextField
                                    error={Boolean(touched.bu && errors.bu)}
                                    fullWidth
                                    helperText={touched.bu && errors.bu}
                                    label="Bu"
                                    margin="normal"
                                    name="bu"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.bu}
                                    variant="outlined"
                                    sx={{
                                        "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            fontFamily: 'CPF_Imm_Sook',
                                            //fontWeight: "bold",
                                            fontSize: 18
                                        },
                                    }}
                                />
                                <TextField
                                    error={Boolean(touched.plant && errors.plant)}
                                    fullWidth
                                    helperText={touched.plant && errors.plant}
                                    label="Plant Id"
                                    margin="normal"
                                    name="plant"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.plant}
                                    variant="outlined"
                                    sx={{
                                        "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            fontFamily: 'CPF_Imm_Sook',
                                            //fontWeight: "bold",
                                            fontSize: 18
                                        },
                                    }}
                                />

                                <TextField
                                    error={Boolean(touched.factory && errors.factory)}
                                    fullWidth
                                    helperText={touched.factory && errors.factory}
                                    label="Factory"
                                    margin="normal"
                                    name="factory"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.factory}
                                    variant="outlined"
                                    sx={{
                                        "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            fontFamily: 'CPF_Imm_Sook',
                                            //fontWeight: "bold",
                                            fontSize: 18
                                        },
                                    }}
                                />
                                <TextField
                                    error={Boolean(touched.line && errors.line)}
                                    fullWidth
                                    helperText={touched.line && errors.line}
                                    label="Line"
                                    margin="normal"
                                    name="line"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.line}
                                    variant="outlined"
                                    sx={{
                                        "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            fontFamily: 'CPF_Imm_Sook',
                                            //fontWeight: "bold",
                                            fontSize: 18
                                        },
                                    }}
                                />
                                <TextField
                                    error={Boolean(touched.module && errors.module)}
                                    fullWidth
                                    helperText={touched.module && errors.module}
                                    label="Module"
                                    margin="normal"
                                    name="module"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.module}
                                    variant="outlined"
                                    sx={{
                                        "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            fontFamily: 'CPF_Imm_Sook',
                                            //fontWeight: "bold",
                                            fontSize: 18
                                        },
                                    }}
                                />
                                <TextField
                                    error={Boolean(touched.status && errors.status)}
                                    fullWidth
                                    helperText={touched.status && errors.status}
                                    label="Status"
                                    margin="normal"
                                    name="status"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.status}
                                    variant="outlined"
                                    sx={{
                                        "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            fontFamily: 'CPF_Imm_Sook',
                                            //fontWeight: "bold",
                                            fontSize: 18
                                        },
                                    }}
                                />

                                <Box
                                    sx={{
                                        alignItems: 'center',
                                        display: 'flex',
                                        ml: -1
                                    }}
                                >
                                </Box>
                                <Divider />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        p: 2
                                    }}
                                >
                                    <Button
                                        style={{ background: '#575755', color: "white", fontSize: 18 }}
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        component={RouterLink}
                                        to="/setting/list-master-plant"
                                        sx={{ mr: 3 }}
                                    >
                                        <ArrowLeftIcon />
                                        Back to master plant
                                    </Button>
                                    <Button
                                        style={{ background: '#009688', color: "white", fontSize: 18 }}
                                        disabled={isSubmitting}
                                        //fullWidth
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                    >
                                        Create new master plant
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Box>
        </>
    );
};

export default NewMasterPlant;
